import React from "react";
import { Handshake, FilePdf, ShieldCheck, Signature } from "@phosphor-icons/react";
import ComingSoonShell from "@/components/ComingSoonShell";

export default function MandatiComingSoon() {
  return (
    <ComingSoonShell
      testid="coming-soon-mandati"
      title={<>Mandati di <span className="font-editorial italic">vendita.</span></>}
      intro="Firma digitale dei mandati di vendita direttamente da Pronto. Esclusivo, non esclusivo, in collaborazione — pre-compilati con i dati del proprietario e della stima. Zero stampe, zero carta, valore legale pieno."
      preview={(
        <div className="flex items-center gap-4">
          <div className="shrink-0 w-24 h-24 rounded-xl border-2 border-[#1C1C1A] bg-[#F1F4ED] inline-flex items-center justify-center">
            <Handshake size={36} weight="duotone" className="text-[#7C8B6E]" />
          </div>
          <div className="flex-1 min-w-0 text-[13px] text-[#3A3A36] leading-relaxed">
            <div className="font-semibold text-[#1C1C1A] mb-1">Dalla stima alla firma in 5 minuti</div>
            Dopo la stima invii al proprietario il link al mandato già compilato.
            Lui firma dal cellulare con SPID o CIE. Il PDF firmato torna in
            Pronto pronto da archiviare.
          </div>
        </div>
      )}
      whyNotYet="La firma digitale con valore legale in Italia richiede integrazione con un provider eIDAS qualificato (es. Namirial, InfoCert). Stiamo selezionando il partner giusto per garantire validità legale piena al 100% — non vogliamo lanciare 'firme finte' che poi non reggono in caso di contestazione."
      whatItWillDo={[
        { icon: FilePdf, label: "Template pre-compilati", body: "Esclusivo, non esclusivo, mediazione semplice, in collaborazione — tutti i template del FIAIP e dei principali franchising, già conformi e personalizzabili col tuo logo." },
        { icon: Signature, label: "Firma con SPID o CIE", body: "Il proprietario firma dal proprio cellulare. Bastano 30 secondi e l'identità è verificata. Niente fax, niente raccomandate, niente uffici postali." },
        { icon: ShieldCheck, label: "Valore legale eIDAS", body: "Firme qualificate equivalenti alla firma manoscritta sulla carta. Archiviazione sostitutiva inclusa, scadenze automatiche, revoca con notifica al proprietario." },
      ]}
      interestSlug="mandati"
      interestTitle="Mandati di vendita con firma digitale"
    />
  );
}
